import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const TableManagerActivations = (props) => {
    const { rows } = props || {};

    return rows?.map((row) => (
        <TableRow
            key={row.name}
            sx={{
                "&:last-child td, &:last-child th": {
                    border: 0,
                },
            }}
        >
            <TableCell component="th" scope="row">
                {row.date}
            </TableCell>

            <TableCell align="right">{row.activations}</TableCell>
            <TableCell align="right">{row.deactivations}</TableCell>
        </TableRow>
    ));
};

export default TableManagerActivations;
